import { render, staticRenderFns } from "./ColorSwatches.vue?vue&type=template&id=3436726e&scoped=true&"
import script from "./ColorSwatches.vue?vue&type=script&lang=js&"
export * from "./ColorSwatches.vue?vue&type=script&lang=js&"
import style0 from "./ColorSwatches.vue?vue&type=style&index=0&id=3436726e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3436726e",
  null
  
)

export default component.exports